module.exports = __webpack_public_path__ + "media/images/import-green-0fdfdc9d.png";